import { lazy } from 'react';

/**
 * Lazy-loaded component for the main application for an __✅ authenticated__ user.
 */
export const Main = lazy(() => import('./Main'));
export { Main as default };
